import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DaslockDashboardPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "daslock-dashboard-page" */ '../../pages/daslock-dashboard'
    ),
);

const dasloopDashboardRouter = (
  <Route path="daslock-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="daslock-dashboard"
            component={<DaslockDashboardPageComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasloopDashboardRouter;
